import { TicketRepository } from '../repositories/TicketRepository'

export function ListNameAreaCase(ticketRepository: TicketRepository) {
  return async function () {
    return await ticketRepository.listNameArea()
  }
}
